import { useMemo } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import Navbar from "./components/shared/Navbar";
import MobileBottomNav from "./components/shared/MobileBottomNav";

// Shows Navbar/MobileBottomNav when logged in, but does NOT enforce auth.
// Used for publicRoutes so logged-out users still see public pages.
const PublicRoute = () => {
  const location = useLocation();
  const userData = useSelector((state) => state.auth?.userData);
  const token = localStorage.getItem("profile");
  const accessToken = useMemo(
    () => JSON.parse(token || "null")?.accessToken,
    [token]
  );

  const isAuthenticated = !!userData && !!accessToken;
  
  // Hide navbar on auth page
  const isAuthPage = location.pathname === "/auth";

  // Always show Navbar (even when logged out), but hide on auth page and only show MobileBottomNav when authenticated
  return (
    <div className="scroll-smooth">
      {!isAuthPage && <Navbar userData={userData} />}

      <div className={`mx-auto w-full md:w-[99%] ${!isAuthPage ? 'mt-2 md:mt-3' : ''} px-2 md:px-0 pb-20 md:pb-0`}>
        <div className={`${!isAuthPage ? 'mt-1 md:mt-1' : ''} min-h-[85vh]`}>
          <Outlet />
        </div>
      </div>

      {isAuthenticated && <MobileBottomNav user={userData} />}
    </div>
  );
};

export default PublicRoute;

